<script setup lang="ts">
import { formatDuration } from '@/helpers/date'
import { computed } from 'vue'
import type { PathwayEvent } from '@/types/shared/pathway-event'
import { usePathwayEvent } from '@/composables/game/pathway-events'

const props = defineProps<{
	pathwayEvent: PathwayEvent
}>()

const { countdownForEventEnd } = usePathwayEvent(props.pathwayEvent)

const containerStyle = computed(() => {
  return { background: `linear-gradient(90deg, ${props.pathwayEvent.mainColor} 0%, #1C1C1E 100%)` }
})
</script>

<template>
  <div
    v-if="pathwayEvent"
    class="flex flex-col items-center justify-center pt-2.5"
  >
    <div class="bg-pathway-events-container relative flex items-center justify-center size-12 rounded-[15px] p-0.5">
      <div
        class="w-full h-full flex items-center justify-center rounded-[14px]"
        :style="containerStyle"
      >
        <div class="absolute -right-2.5 -top-1.5 w-[38px] auto z-[5]">
          <img
            class="w-full h-full badge-shadow object-cover"
            src="@/assets/images/pathway-events-badge.png"
          >
          <div
            class="absolute rotate-[29deg] top-1/2 left-1/2 translate-x-[calc(-50%)] translate-y-[calc(-50%)] w-full overflow-visible"
          >
            <span
              class="badge-text-shadow white-stroke text-tropee-black pathway-badge-text uppercase font-bold text-[10px] leading-[9px] whitespace-pre-line w-full overflow-visible inline-block h-max text-center"
              v-html="pathwayEvent.eventName"
            />
          </div>
        </div>
        <img
          class="size-[38px] object-cover"
          :src="pathwayEvent.mainIcon"
        >
      </div>
    </div>
    <div class="z-[10] flex flex-col -mt-2 items-center">
      <div
        class="z-[2] whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] tabular-nums"
        :class="countdownForEventEnd < (3600 * 12) ? 'text-red-danger' : 'text-tropee-black'"
      >
        {{ formatDuration(countdownForEventEnd, undefined, countdownForEventEnd > (3600 * 72)) }}
      </div>
    </div>
  </div>
</template>
<style scoped>
.bg-pathway-events-container {
	background: linear-gradient(
		to top,
		rgba(237, 252, 202, 0.22) 13%,
		#48650C 24%,
		#3B9A7C 42%,
		#3B9A7C 63%,
		rgba(238, 255, 202, 0.77) 79%,
		#E2FFA7 82%
	);
}

.pathway-badge-text::first-line {
	@apply text-[11px] leading-[10px];
}

.white-stroke {
	-webkit-text-stroke-width: 0.5px;
	-webkit-text-stroke-color: #FFF;
	paint-order: stroke fill;
}

.badge-text-shadow {
	filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.badge-shadow {
	filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}
</style>
